<template>
  <div class="container-fluid grayed-offset">
    <VTest :default-test="defaultTest" :test-diffs="testDiffs" :component="VSubscription" i18n="internalcatalogue">
      <template #item="{ n, test, component }">
        <h3
          >Test #{{ n }}: <small>{{ test.testDescription }}</small></h3
        >
        <component :is="component" v-bind="test" />
      </template>
    </VTest>
  </div>
</template>

<script>
import VTest from '@/components/Test';
import VSubscription from '@/components/Substore/InternalCatalogue/Subscription';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'SubscriptionTest',

  components: {
    VTest,
  },

  data() {
    return {
      defaultTest,
      testDiffs,
      VSubscription,
    };
  },
};
</script>
